module.exports = __webpack_public_path__ + "icon_cached-98a757f1d9e93652742be43c22f46287.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/icon_cached.png
// module id = 270
// module chunks = 70